module.exports = __webpack_public_path__ + "static/google-play-button-d2e12168f05dc9bfcd53126633325496.svg";